export interface Country {
  country: string;
  alpha2code: string;
  alpha3code: string;
  numericCode: number;
}


export const COUNTRIES: Country[] = [
  {
    country: 'Germany',
    alpha2code: 'DE',
    alpha3code: 'DEU',
    numericCode: 276
  },
  {
    country: 'Austria',
    alpha2code: 'AT',
    alpha3code: 'AUT',
    numericCode: 40
  },
  {
    country: 'Switzerland',
    alpha2code: 'CH',
    alpha3code: 'CHE',
    numericCode: 756
  },
  {
    country: 'Afghanistan',
    alpha2code: 'AF',
    alpha3code: 'AFG',
    numericCode: 4
  },
  {
    country: 'Åland Islands',
    alpha2code: 'AX',
    alpha3code: 'ALA',
    numericCode: 248
  },
  {
    country: 'Albania',
    alpha2code: 'AL',
    alpha3code: 'ALB',
    numericCode: 8
  },
  {
    country: 'Algeria',
    alpha2code: 'DZ',
    alpha3code: 'DZA',
    numericCode: 12
  },
  {
    country: 'American Samoa',
    alpha2code: 'AS',
    alpha3code: 'ASM',
    numericCode: 16
  },
  {
    country: 'Andorra',
    alpha2code: 'AD',
    alpha3code: 'AND',
    numericCode: 20
  },
  {
    country: 'Angola',
    alpha2code: 'AO',
    alpha3code: 'AGO',
    numericCode: 24
  },
  {
    country: 'Anguilla',
    alpha2code: 'AI',
    alpha3code: 'AIA',
    numericCode: 660
  },
  {
    country: 'Antarctica',
    alpha2code: 'AQ',
    alpha3code: 'ATA',
    numericCode: 10
  },
  {
    country: 'Antigua and Barbuda',
    alpha2code: 'AG',
    alpha3code: 'ATG',
    numericCode: 28
  },
  {
    country: 'Argentina',
    alpha2code: 'AR',
    alpha3code: 'ARG',
    numericCode: 32
  },
  {
    country: 'Armenia',
    alpha2code: 'AM',
    alpha3code: 'ARM',
    numericCode: 51
  },
  {
    country: 'Aruba',
    alpha2code: 'AW',
    alpha3code: 'ABW',
    numericCode: 533
  },
  {
    country: 'Australia',
    alpha2code: 'AU',
    alpha3code: 'AUS',
    numericCode: 36
  },
  {
    country: 'Azerbaijan',
    alpha2code: 'AZ',
    alpha3code: 'AZE',
    numericCode: 31
  },
  {
    country: 'Bahamas (the)',
    alpha2code: 'BS',
    alpha3code: 'BHS',
    numericCode: 44
  },
  {
    country: 'Bahrain',
    alpha2code: 'BH',
    alpha3code: 'BHR',
    numericCode: 48
  },
  {
    country: 'Bangladesh',
    alpha2code: 'BD',
    alpha3code: 'BGD',
    numericCode: 50
  },
  {
    country: 'Barbados',
    alpha2code: 'BB',
    alpha3code: 'BRB',
    numericCode: 52
  },
  {
    country: 'Belarus',
    alpha2code: 'BY',
    alpha3code: 'BLR',
    numericCode: 112
  },
  {
    country: 'Belgium',
    alpha2code: 'BE',
    alpha3code: 'BEL',
    numericCode: 56
  },
  {
    country: 'Belize',
    alpha2code: 'BZ',
    alpha3code: 'BLZ',
    numericCode: 84
  },
  {
    country: 'Benin',
    alpha2code: 'BJ',
    alpha3code: 'BEN',
    numericCode: 204
  },
  {
    country: 'Bermuda',
    alpha2code: 'BM',
    alpha3code: 'BMU',
    numericCode: 60
  },
  {
    country: 'Bhutan',
    alpha2code: 'BT',
    alpha3code: 'BTN',
    numericCode: 64
  },
  {
    country: 'Bolivia (Plurinational State of)',
    alpha2code: 'BO',
    alpha3code: 'BOL',
    numericCode: 68
  },
  {
    country: 'Bonaire, Sint Eustatius and Saba',
    alpha2code: 'BQ',
    alpha3code: 'BES',
    numericCode: 535
  },
  {
    country: 'Bosnia and Herzegovina',
    alpha2code: 'BA',
    alpha3code: 'BIH',
    numericCode: 70
  },
  {
    country: 'Botswana',
    alpha2code: 'BW',
    alpha3code: 'BWA',
    numericCode: 72
  },
  {
    country: 'Bouvet Island',
    alpha2code: 'BV',
    alpha3code: 'BVT',
    numericCode: 74
  },
  {
    country: 'Brazil',
    alpha2code: 'BR',
    alpha3code: 'BRA',
    numericCode: 76
  },
  {
    country: 'British Indian Ocean Territory (the)',
    alpha2code: 'IO',
    alpha3code: 'IOT',
    numericCode: 86
  },
  {
    country: 'Brunei Darussalam',
    alpha2code: 'BN',
    alpha3code: 'BRN',
    numericCode: 96
  },
  {
    country: 'Bulgaria',
    alpha2code: 'BG',
    alpha3code: 'BGR',
    numericCode: 100
  },
  {
    country: 'Burkina Faso',
    alpha2code: 'BF',
    alpha3code: 'BFA',
    numericCode: 854
  },
  {
    country: 'Burundi',
    alpha2code: 'BI',
    alpha3code: 'BDI',
    numericCode: 108
  },
  {
    country: 'Cabo Verde',
    alpha2code: 'CV',
    alpha3code: 'CPV',
    numericCode: 132
  },
  {
    country: 'Cambodia',
    alpha2code: 'KH',
    alpha3code: 'KHM',
    numericCode: 116
  },
  {
    country: 'Cameroon',
    alpha2code: 'CM',
    alpha3code: 'CMR',
    numericCode: 120
  },
  {
    country: 'Canada',
    alpha2code: 'CA',
    alpha3code: 'CAN',
    numericCode: 124
  },
  {
    country: 'Cayman Islands (the)',
    alpha2code: 'KY',
    alpha3code: 'CYM',
    numericCode: 136
  },
  {
    country: 'Central African Republic (the)',
    alpha2code: 'CF',
    alpha3code: 'CAF',
    numericCode: 140
  },
  {
    country: 'Chad',
    alpha2code: 'TD',
    alpha3code: 'TCD',
    numericCode: 148
  },
  {
    country: 'Chile',
    alpha2code: 'CL',
    alpha3code: 'CHL',
    numericCode: 152
  },
  {
    country: 'China',
    alpha2code: 'CN',
    alpha3code: 'CHN',
    numericCode: 156
  },
  {
    country: 'Christmas Island',
    alpha2code: 'CX',
    alpha3code: 'CXR',
    numericCode: 162
  },
  {
    country: 'Cocos (Keeling) Islands (the)',
    alpha2code: 'CC',
    alpha3code: 'CCK',
    numericCode: 166
  },
  {
    country: 'Colombia',
    alpha2code: 'CO',
    alpha3code: 'COL',
    numericCode: 170
  },
  {
    country: 'Comoros (the)',
    alpha2code: 'KM',
    alpha3code: 'COM',
    numericCode: 174
  },
  {
    country: 'Congo (the Democratic Republic of the)',
    alpha2code: 'CD',
    alpha3code: 'COD',
    numericCode: 180
  },
  {
    country: 'Congo (the)',
    alpha2code: 'CG',
    alpha3code: 'COG',
    numericCode: 178
  },
  {
    country: 'Cook Islands (the)',
    alpha2code: 'CK',
    alpha3code: 'COK',
    numericCode: 184
  },
  {
    country: 'Costa Rica',
    alpha2code: 'CR',
    alpha3code: 'CRI',
    numericCode: 188
  },
  {
    country: 'Côte d\'Ivoire',
    alpha2code: 'CI',
    alpha3code: 'CIV',
    numericCode: 384
  },
  {
    country: 'Croatia',
    alpha2code: 'HR',
    alpha3code: 'HRV',
    numericCode: 191
  },
  {
    country: 'Cuba',
    alpha2code: 'CU',
    alpha3code: 'CUB',
    numericCode: 192
  },
  {
    country: 'Curaçao',
    alpha2code: 'CW',
    alpha3code: 'CUW',
    numericCode: 531
  },
  {
    country: 'Cyprus',
    alpha2code: 'CY',
    alpha3code: 'CYP',
    numericCode: 196
  },
  {
    country: 'Czechia',
    alpha2code: 'CZ',
    alpha3code: 'CZE',
    numericCode: 203
  },
  {
    country: 'Denmark',
    alpha2code: 'DK',
    alpha3code: 'DNK',
    numericCode: 208
  },
  {
    country: 'Djibouti',
    alpha2code: 'DJ',
    alpha3code: 'DJI',
    numericCode: 262
  },
  {
    country: 'Dominica',
    alpha2code: 'DM',
    alpha3code: 'DMA',
    numericCode: 212
  },
  {
    country: 'Dominican Republic (the)',
    alpha2code: 'DO',
    alpha3code: 'DOM',
    numericCode: 214
  },
  {
    country: 'Ecuador',
    alpha2code: 'EC',
    alpha3code: 'ECU',
    numericCode: 218
  },
  {
    country: 'Egypt',
    alpha2code: 'EG',
    alpha3code: 'EGY',
    numericCode: 818
  },
  {
    country: 'El Salvador',
    alpha2code: 'SV',
    alpha3code: 'SLV',
    numericCode: 222
  },
  {
    country: 'Equatorial Guinea',
    alpha2code: 'GQ',
    alpha3code: 'GNQ',
    numericCode: 226
  },
  {
    country: 'Eritrea',
    alpha2code: 'ER',
    alpha3code: 'ERI',
    numericCode: 232
  },
  {
    country: 'Estonia',
    alpha2code: 'EE',
    alpha3code: 'EST',
    numericCode: 233
  },
  {
    country: 'Eswatini',
    alpha2code: 'SZ',
    alpha3code: 'SWZ',
    numericCode: 748
  },
  {
    country: 'Ethiopia',
    alpha2code: 'ET',
    alpha3code: 'ETH',
    numericCode: 231
  },
  {
    country: 'Falkland Islands (the) [Malvinas]',
    alpha2code: 'FK',
    alpha3code: 'FLK',
    numericCode: 238
  },
  {
    country: 'Faroe Islands (the)',
    alpha2code: 'FO',
    alpha3code: 'FRO',
    numericCode: 234
  },
  {
    country: 'Fiji',
    alpha2code: 'FJ',
    alpha3code: 'FJI',
    numericCode: 242
  },
  {
    country: 'Finland',
    alpha2code: 'FI',
    alpha3code: 'FIN',
    numericCode: 246
  },
  {
    country: 'France',
    alpha2code: 'FR',
    alpha3code: 'FRA',
    numericCode: 250
  },
  {
    country: 'French Guiana',
    alpha2code: 'GF',
    alpha3code: 'GUF',
    numericCode: 254
  },
  {
    country: 'French Polynesia',
    alpha2code: 'PF',
    alpha3code: 'PYF',
    numericCode: 258
  },
  {
    country: 'French Southern Territories (the)',
    alpha2code: 'TF',
    alpha3code: 'ATF',
    numericCode: 260
  },
  {
    country: 'Gabon',
    alpha2code: 'GA',
    alpha3code: 'GAB',
    numericCode: 266
  },
  {
    country: 'Gambia (the)',
    alpha2code: 'GM',
    alpha3code: 'GMB',
    numericCode: 270
  },
  {
    country: 'Georgia',
    alpha2code: 'GE',
    alpha3code: 'GEO',
    numericCode: 268
  },
  {
    country: 'Ghana',
    alpha2code: 'GH',
    alpha3code: 'GHA',
    numericCode: 288
  },
  {
    country: 'Gibraltar',
    alpha2code: 'GI',
    alpha3code: 'GIB',
    numericCode: 292
  },
  {
    country: 'Greece',
    alpha2code: 'GR',
    alpha3code: 'GRC',
    numericCode: 300
  },
  {
    country: 'Greenland',
    alpha2code: 'GL',
    alpha3code: 'GRL',
    numericCode: 304
  },
  {
    country: 'Grenada',
    alpha2code: 'GD',
    alpha3code: 'GRD',
    numericCode: 308
  },
  {
    country: 'Guadeloupe',
    alpha2code: 'GP',
    alpha3code: 'GLP',
    numericCode: 312
  },
  {
    country: 'Guam',
    alpha2code: 'GU',
    alpha3code: 'GUM',
    numericCode: 316
  },
  {
    country: 'Guatemala',
    alpha2code: 'GT',
    alpha3code: 'GTM',
    numericCode: 320
  },
  {
    country: 'Guernsey',
    alpha2code: 'GG',
    alpha3code: 'GGY',
    numericCode: 831
  },
  {
    country: 'Guinea',
    alpha2code: 'GN',
    alpha3code: 'GIN',
    numericCode: 324
  },
  {
    country: 'Guinea-Bissau',
    alpha2code: 'GW',
    alpha3code: 'GNB',
    numericCode: 624
  },
  {
    country: 'Guyana',
    alpha2code: 'GY',
    alpha3code: 'GUY',
    numericCode: 328
  },
  {
    country: 'Haiti',
    alpha2code: 'HT',
    alpha3code: 'HTI',
    numericCode: 332
  },
  {
    country: 'Heard Island and McDonald Islands',
    alpha2code: 'HM',
    alpha3code: 'HMD',
    numericCode: 334
  },
  {
    country: 'Holy See (the)',
    alpha2code: 'VA',
    alpha3code: 'VAT',
    numericCode: 336
  },
  {
    country: 'Honduras',
    alpha2code: 'HN',
    alpha3code: 'HND',
    numericCode: 340
  },
  {
    country: 'Hong Kong',
    alpha2code: 'HK',
    alpha3code: 'HKG',
    numericCode: 344
  },
  {
    country: 'Hungary',
    alpha2code: 'HU',
    alpha3code: 'HUN',
    numericCode: 348
  },
  {
    country: 'Iceland',
    alpha2code: 'IS',
    alpha3code: 'ISL',
    numericCode: 352
  },
  {
    country: 'India',
    alpha2code: 'IN',
    alpha3code: 'IND',
    numericCode: 356
  },
  {
    country: 'Indonesia',
    alpha2code: 'ID',
    alpha3code: 'IDN',
    numericCode: 360
  },
  {
    country: 'Iran (Islamic Republic of)',
    alpha2code: 'IR',
    alpha3code: 'IRN',
    numericCode: 364
  },
  {
    country: 'Iraq',
    alpha2code: 'IQ',
    alpha3code: 'IRQ',
    numericCode: 368
  },
  {
    country: 'Ireland',
    alpha2code: 'IE',
    alpha3code: 'IRL',
    numericCode: 372
  },
  {
    country: 'Isle of Man',
    alpha2code: 'IM',
    alpha3code: 'IMN',
    numericCode: 833
  },
  {
    country: 'Israel',
    alpha2code: 'IL',
    alpha3code: 'ISR',
    numericCode: 376
  },
  {
    country: 'Italy',
    alpha2code: 'IT',
    alpha3code: 'ITA',
    numericCode: 380
  },
  {
    country: 'Jamaica',
    alpha2code: 'JM',
    alpha3code: 'JAM',
    numericCode: 388
  },
  {
    country: 'Japan',
    alpha2code: 'JP',
    alpha3code: 'JPN',
    numericCode: 392
  },
  {
    country: 'Jersey',
    alpha2code: 'JE',
    alpha3code: 'JEY',
    numericCode: 832
  },
  {
    country: 'Jordan',
    alpha2code: 'JO',
    alpha3code: 'JOR',
    numericCode: 400
  },
  {
    country: 'Kazakhstan',
    alpha2code: 'KZ',
    alpha3code: 'KAZ',
    numericCode: 398
  },
  {
    country: 'Kenya',
    alpha2code: 'KE',
    alpha3code: 'KEN',
    numericCode: 404
  },
  {
    country: 'Kiribati',
    alpha2code: 'KI',
    alpha3code: 'KIR',
    numericCode: 296
  },
  {
    country: 'Korea (the Democratic People\'s Republic of)',
    alpha2code: 'KP',
    alpha3code: 'PRK',
    numericCode: 408
  },
  {
    country: 'Korea (the Republic of)',
    alpha2code: 'KR',
    alpha3code: 'KOR',
    numericCode: 410
  },
  {
    country: 'Kuwait',
    alpha2code: 'KW',
    alpha3code: 'KWT',
    numericCode: 414
  },
  {
    country: 'Kyrgyzstan',
    alpha2code: 'KG',
    alpha3code: 'KGZ',
    numericCode: 417
  },
  {
    country: 'Lao People\'s Democratic Republic (the)',
    alpha2code: 'LA',
    alpha3code: 'LAO',
    numericCode: 418
  },
  {
    country: 'Latvia',
    alpha2code: 'LV',
    alpha3code: 'LVA',
    numericCode: 428
  },
  {
    country: 'Lebanon',
    alpha2code: 'LB',
    alpha3code: 'LBN',
    numericCode: 422
  },
  {
    country: 'Lesotho',
    alpha2code: 'LS',
    alpha3code: 'LSO',
    numericCode: 426
  },
  {
    country: 'Liberia',
    alpha2code: 'LR',
    alpha3code: 'LBR',
    numericCode: 430
  },
  {
    country: 'Libya',
    alpha2code: 'LY',
    alpha3code: 'LBY',
    numericCode: 434
  },
  {
    country: 'Liechtenstein',
    alpha2code: 'LI',
    alpha3code: 'LIE',
    numericCode: 438
  },
  {
    country: 'Lithuania',
    alpha2code: 'LT',
    alpha3code: 'LTU',
    numericCode: 440
  },
  {
    country: 'Luxembourg',
    alpha2code: 'LU',
    alpha3code: 'LUX',
    numericCode: 442
  },
  {
    country: 'Macao',
    alpha2code: 'MO',
    alpha3code: 'MAC',
    numericCode: 446
  },
  {
    country: 'Republic of North Macedonia',
    alpha2code: 'MK',
    alpha3code: 'MKD',
    numericCode: 807
  },
  {
    country: 'Madagascar',
    alpha2code: 'MG',
    alpha3code: 'MDG',
    numericCode: 450
  },
  {
    country: 'Malawi',
    alpha2code: 'MW',
    alpha3code: 'MWI',
    numericCode: 454
  },
  {
    country: 'Malaysia',
    alpha2code: 'MY',
    alpha3code: 'MYS',
    numericCode: 458
  },
  {
    country: 'Maldives',
    alpha2code: 'MV',
    alpha3code: 'MDV',
    numericCode: 462
  },
  {
    country: 'Mali',
    alpha2code: 'ML',
    alpha3code: 'MLI',
    numericCode: 466
  },
  {
    country: 'Malta',
    alpha2code: 'MT',
    alpha3code: 'MLT',
    numericCode: 470
  },
  {
    country: 'Marshall Islands (the)',
    alpha2code: 'MH',
    alpha3code: 'MHL',
    numericCode: 584
  },
  {
    country: 'Martinique',
    alpha2code: 'MQ',
    alpha3code: 'MTQ',
    numericCode: 474
  },
  {
    country: 'Mauritania',
    alpha2code: 'MR',
    alpha3code: 'MRT',
    numericCode: 478
  },
  {
    country: 'Mauritius',
    alpha2code: 'MU',
    alpha3code: 'MUS',
    numericCode: 480
  },
  {
    country: 'Mayotte',
    alpha2code: 'YT',
    alpha3code: 'MYT',
    numericCode: 175
  },
  {
    country: 'Mexico',
    alpha2code: 'MX',
    alpha3code: 'MEX',
    numericCode: 484
  },
  {
    country: 'Micronesia (Federated States of)',
    alpha2code: 'FM',
    alpha3code: 'FSM',
    numericCode: 583
  },
  {
    country: 'Moldova (the Republic of)',
    alpha2code: 'MD',
    alpha3code: 'MDA',
    numericCode: 498
  },
  {
    country: 'Monaco',
    alpha2code: 'MC',
    alpha3code: 'MCO',
    numericCode: 492
  },
  {
    country: 'Mongolia',
    alpha2code: 'MN',
    alpha3code: 'MNG',
    numericCode: 496
  },
  {
    country: 'Montenegro',
    alpha2code: 'ME',
    alpha3code: 'MNE',
    numericCode: 499
  },
  {
    country: 'Montserrat',
    alpha2code: 'MS',
    alpha3code: 'MSR',
    numericCode: 500
  },
  {
    country: 'Morocco',
    alpha2code: 'MA',
    alpha3code: 'MAR',
    numericCode: 504
  },
  {
    country: 'Mozambique',
    alpha2code: 'MZ',
    alpha3code: 'MOZ',
    numericCode: 508
  },
  {
    country: 'Myanmar',
    alpha2code: 'MM',
    alpha3code: 'MMR',
    numericCode: 104
  },
  {
    country: 'Namibia',
    alpha2code: 'NA',
    alpha3code: 'NAM',
    numericCode: 516
  },
  {
    country: 'Nauru',
    alpha2code: 'NR',
    alpha3code: 'NRU',
    numericCode: 520
  },
  {
    country: 'Nepal',
    alpha2code: 'NP',
    alpha3code: 'NPL',
    numericCode: 524
  },
  {
    country: 'Netherlands (the)',
    alpha2code: 'NL',
    alpha3code: 'NLD',
    numericCode: 528
  },
  {
    country: 'New Caledonia',
    alpha2code: 'NC',
    alpha3code: 'NCL',
    numericCode: 540
  },
  {
    country: 'New Zealand',
    alpha2code: 'NZ',
    alpha3code: 'NZL',
    numericCode: 554
  },
  {
    country: 'Nicaragua',
    alpha2code: 'NI',
    alpha3code: 'NIC',
    numericCode: 558
  },
  {
    country: 'Niger (the)',
    alpha2code: 'NE',
    alpha3code: 'NER',
    numericCode: 562
  },
  {
    country: 'Nigeria',
    alpha2code: 'NG',
    alpha3code: 'NGA',
    numericCode: 566
  },
  {
    country: 'Niue',
    alpha2code: 'NU',
    alpha3code: 'NIU',
    numericCode: 570
  },
  {
    country: 'Norfolk Island',
    alpha2code: 'NF',
    alpha3code: 'NFK',
    numericCode: 574
  },
  {
    country: 'Northern Mariana Islands (the)',
    alpha2code: 'MP',
    alpha3code: 'MNP',
    numericCode: 580
  },
  {
    country: 'Norway',
    alpha2code: 'NO',
    alpha3code: 'NOR',
    numericCode: 578
  },
  {
    country: 'Oman',
    alpha2code: 'OM',
    alpha3code: 'OMN',
    numericCode: 512
  },
  {
    country: 'Pakistan',
    alpha2code: 'PK',
    alpha3code: 'PAK',
    numericCode: 586
  },
  {
    country: 'Palau',
    alpha2code: 'PW',
    alpha3code: 'PLW',
    numericCode: 585
  },
  {
    country: 'Palestine, State of',
    alpha2code: 'PS',
    alpha3code: 'PSE',
    numericCode: 275
  },
  {
    country: 'Panama',
    alpha2code: 'PA',
    alpha3code: 'PAN',
    numericCode: 591
  },
  {
    country: 'Papua New Guinea',
    alpha2code: 'PG',
    alpha3code: 'PNG',
    numericCode: 598
  },
  {
    country: 'Paraguay',
    alpha2code: 'PY',
    alpha3code: 'PRY',
    numericCode: 600
  },
  {
    country: 'Peru',
    alpha2code: 'PE',
    alpha3code: 'PER',
    numericCode: 604
  },
  {
    country: 'Philippines (the)',
    alpha2code: 'PH',
    alpha3code: 'PHL',
    numericCode: 608
  },
  {
    country: 'Pitcairn',
    alpha2code: 'PN',
    alpha3code: 'PCN',
    numericCode: 612
  },
  {
    country: 'Poland',
    alpha2code: 'PL',
    alpha3code: 'POL',
    numericCode: 616
  },
  {
    country: 'Portugal',
    alpha2code: 'PT',
    alpha3code: 'PRT',
    numericCode: 620
  },
  {
    country: 'Puerto Rico',
    alpha2code: 'PR',
    alpha3code: 'PRI',
    numericCode: 630
  },
  {
    country: 'Qatar',
    alpha2code: 'QA',
    alpha3code: 'QAT',
    numericCode: 634
  },
  {
    country: 'Réunion',
    alpha2code: 'RE',
    alpha3code: 'REU',
    numericCode: 638
  },
  {
    country: 'Romania',
    alpha2code: 'RO',
    alpha3code: 'ROU',
    numericCode: 642
  },
  {
    country: 'Russian Federation (the)',
    alpha2code: 'RU',
    alpha3code: 'RUS',
    numericCode: 643
  },
  {
    country: 'Rwanda',
    alpha2code: 'RW',
    alpha3code: 'RWA',
    numericCode: 646
  },
  {
    country: 'Saint Barthélemy',
    alpha2code: 'BL',
    alpha3code: 'BLM',
    numericCode: 652
  },
  {
    country: 'Saint Helena, Ascension and Tristan da Cunha',
    alpha2code: 'SH',
    alpha3code: 'SHN',
    numericCode: 654
  },
  {
    country: 'Saint Kitts and Nevis',
    alpha2code: 'KN',
    alpha3code: 'KNA',
    numericCode: 659
  },
  {
    country: 'Saint Lucia',
    alpha2code: 'LC',
    alpha3code: 'LCA',
    numericCode: 662
  },
  {
    country: 'Saint Martin (French part)',
    alpha2code: 'MF',
    alpha3code: 'MAF',
    numericCode: 663
  },
  {
    country: 'Saint Pierre and Miquelon',
    alpha2code: 'PM',
    alpha3code: 'SPM',
    numericCode: 666
  },
  {
    country: 'Saint Vincent and the Grenadines',
    alpha2code: 'VC',
    alpha3code: 'VCT',
    numericCode: 670
  },
  {
    country: 'Samoa',
    alpha2code: 'WS',
    alpha3code: 'WSM',
    numericCode: 882
  },
  {
    country: 'San Marino',
    alpha2code: 'SM',
    alpha3code: 'SMR',
    numericCode: 674
  },
  {
    country: 'Sao Tome and Principe',
    alpha2code: 'ST',
    alpha3code: 'STP',
    numericCode: 678
  },
  {
    country: 'Saudi Arabia',
    alpha2code: 'SA',
    alpha3code: 'SAU',
    numericCode: 682
  },
  {
    country: 'Senegal',
    alpha2code: 'SN',
    alpha3code: 'SEN',
    numericCode: 686
  },
  {
    country: 'Serbia',
    alpha2code: 'RS',
    alpha3code: 'SRB',
    numericCode: 688
  },
  {
    country: 'Seychelles',
    alpha2code: 'SC',
    alpha3code: 'SYC',
    numericCode: 690
  },
  {
    country: 'Sierra Leone',
    alpha2code: 'SL',
    alpha3code: 'SLE',
    numericCode: 694
  },
  {
    country: 'Singapore',
    alpha2code: 'SG',
    alpha3code: 'SGP',
    numericCode: 702
  },
  {
    country: 'Sint Maarten (Dutch part)',
    alpha2code: 'SX',
    alpha3code: 'SXM',
    numericCode: 534
  },
  {
    country: 'Slovakia',
    alpha2code: 'SK',
    alpha3code: 'SVK',
    numericCode: 703
  },
  {
    country: 'Slovenia',
    alpha2code: 'SI',
    alpha3code: 'SVN',
    numericCode: 705
  },
  {
    country: 'Solomon Islands',
    alpha2code: 'SB',
    alpha3code: 'SLB',
    numericCode: 90
  },
  {
    country: 'Somalia',
    alpha2code: 'SO',
    alpha3code: 'SOM',
    numericCode: 706
  },
  {
    country: 'South Africa',
    alpha2code: 'ZA',
    alpha3code: 'ZAF',
    numericCode: 710
  },
  {
    country: 'South Georgia and the South Sandwich Islands',
    alpha2code: 'GS',
    alpha3code: 'SGS',
    numericCode: 239
  },
  {
    country: 'South Sudan',
    alpha2code: 'SS',
    alpha3code: 'SSD',
    numericCode: 728
  },
  {
    country: 'Spain',
    alpha2code: 'ES',
    alpha3code: 'ESP',
    numericCode: 724
  },
  {
    country: 'Sri Lanka',
    alpha2code: 'LK',
    alpha3code: 'LKA',
    numericCode: 144
  },
  {
    country: 'Sudan (the)',
    alpha2code: 'SD',
    alpha3code: 'SDN',
    numericCode: 729
  },
  {
    country: 'Suriname',
    alpha2code: 'SR',
    alpha3code: 'SUR',
    numericCode: 740
  },
  {
    country: 'Svalbard and Jan Mayen',
    alpha2code: 'SJ',
    alpha3code: 'SJM',
    numericCode: 744
  },
  {
    country: 'Sweden',
    alpha2code: 'SE',
    alpha3code: 'SWE',
    numericCode: 752
  },
  {
    country: 'Syrian Arab Republic',
    alpha2code: 'SY',
    alpha3code: 'SYR',
    numericCode: 760
  },
  {
    country: 'Taiwan (Province of China)',
    alpha2code: 'TW',
    alpha3code: 'TWN',
    numericCode: 158
  },
  {
    country: 'Tajikistan',
    alpha2code: 'TJ',
    alpha3code: 'TJK',
    numericCode: 762
  },
  {
    country: 'Tanzania, United Republic of',
    alpha2code: 'TZ',
    alpha3code: 'TZA',
    numericCode: 834
  },
  {
    country: 'Thailand',
    alpha2code: 'TH',
    alpha3code: 'THA',
    numericCode: 764
  },
  {
    country: 'Timor-Leste',
    alpha2code: 'TL',
    alpha3code: 'TLS',
    numericCode: 626
  },
  {
    country: 'Togo',
    alpha2code: 'TG',
    alpha3code: 'TGO',
    numericCode: 768
  },
  {
    country: 'Tokelau',
    alpha2code: 'TK',
    alpha3code: 'TKL',
    numericCode: 772
  },
  {
    country: 'Tonga',
    alpha2code: 'TO',
    alpha3code: 'TON',
    numericCode: 776
  },
  {
    country: 'Trinidad and Tobago',
    alpha2code: 'TT',
    alpha3code: 'TTO',
    numericCode: 780
  },
  {
    country: 'Tunisia',
    alpha2code: 'TN',
    alpha3code: 'TUN',
    numericCode: 788
  },
  {
    country: 'Turkey',
    alpha2code: 'TR',
    alpha3code: 'TUR',
    numericCode: 792
  },
  {
    country: 'Turkmenistan',
    alpha2code: 'TM',
    alpha3code: 'TKM',
    numericCode: 795
  },
  {
    country: 'Turks and Caicos Islands (the)',
    alpha2code: 'TC',
    alpha3code: 'TCA',
    numericCode: 796
  },
  {
    country: 'Tuvalu',
    alpha2code: 'TV',
    alpha3code: 'TUV',
    numericCode: 798
  },
  {
    country: 'Uganda',
    alpha2code: 'UG',
    alpha3code: 'UGA',
    numericCode: 800
  },
  {
    country: 'Ukraine',
    alpha2code: 'UA',
    alpha3code: 'UKR',
    numericCode: 804
  },
  {
    country: 'United Arab Emirates (the)',
    alpha2code: 'AE',
    alpha3code: 'ARE',
    numericCode: 784
  },
  {
    country: 'United Kingdom of Great Britain and Northern Ireland (the)',
    alpha2code: 'GB',
    alpha3code: 'GBR',
    numericCode: 826
  },
  {
    country: 'United States Minor Outlying Islands (the)',
    alpha2code: 'UM',
    alpha3code: 'UMI',
    numericCode: 581
  },
  {
    country: 'United States of America (the)',
    alpha2code: 'US',
    alpha3code: 'USA',
    numericCode: 840
  },
  {
    country: 'Uruguay',
    alpha2code: 'UY',
    alpha3code: 'URY',
    numericCode: 858
  },
  {
    country: 'Uzbekistan',
    alpha2code: 'UZ',
    alpha3code: 'UZB',
    numericCode: 860
  },
  {
    country: 'Vanuatu',
    alpha2code: 'VU',
    alpha3code: 'VUT',
    numericCode: 548
  },
  {
    country: 'Venezuela (Bolivarian Republic of)',
    alpha2code: 'VE',
    alpha3code: 'VEN',
    numericCode: 862
  },
  {
    country: 'Viet Nam',
    alpha2code: 'VN',
    alpha3code: 'VNM',
    numericCode: 704
  },
  {
    country: 'Virgin Islands (British)',
    alpha2code: 'VG',
    alpha3code: 'VGB',
    numericCode: 92
  },
  {
    country: 'Virgin Islands (U.S.)',
    alpha2code: 'VI',
    alpha3code: 'VIR',
    numericCode: 850
  },
  {
    country: 'Wallis and Futuna',
    alpha2code: 'WF',
    alpha3code: 'WLF',
    numericCode: 876
  },
  {
    country: 'Western Sahara',
    alpha2code: 'EH',
    alpha3code: 'ESH',
    numericCode: 732
  },
  {
    country: 'Yemen',
    alpha2code: 'YE',
    alpha3code: 'YEM',
    numericCode: 887
  },
  {
    country: 'Zambia',
    alpha2code: 'ZM',
    alpha3code: 'ZMB',
    numericCode: 894
  },
  {
    country: 'Zimbabwe',
    alpha2code: 'ZW',
    alpha3code: 'ZWE',
    numericCode: 716
  }
];
